import { BlankState } from '@domain-group/suit-theme'

import blankImageUrl from './assets/filterBlankState.svg'

const CampaignStatementBlankState = () => (
  <BlankState imageUrl={blankImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>Please Select a Campaign</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      To View the Campaign Statement please select a Campaign using the Filter.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default CampaignStatementBlankState
